// extracted by mini-css-extract-plugin
module.exports = {"slide":"PetForm_slide_15txt","slide-reverse":"PetForm_slide-reverse_1fXvD","footer":"PetForm_footer_3niTu"};